<!-- eslint-disable vue/no-v-html -->
<template>
  <div id="maintenance-view">
    <div class="title-container">
      <div class="page-title">{{ $t("maintenance.title") }}</div>
    </div>
    <div class="message-container">
      <div
        class="maintenance-message"
        v-html="$t('maintenance.message.top')"
      ></div>
    </div>
    <div class="main-message-container">
      <div v-if="maintenanceMessage" class="main-message-wrapper">
        <div class="main-maintenance-title">
          {{ $t("maintenance.main.title") }}
        </div>
        <div class="main-maintenance-message">
          <!-- <br>毎に改行するようにしておく -->
          <span
            v-for="(msg, index) in maintenanceMessage.split('<br>')"
            :key="index"
          >
            <!-- メッセージをjsonファイルから取得する 取得失敗時は表示されない-->
            {{ msg }}
            <br />
          </span>
        </div>
      </div>
    </div>
    <div class="message-container">
      <div
        class="maintenance-message"
        v-html="$t('maintenance.message.bottom')"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maintenanceInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maintenanceMessage: "",
    };
  },
  created() {
    this.getMaintenanceMessage();
  },
  methods: {
    getMaintenanceMessage() {
      const { maintenanceMessage } = this.maintenanceInfo;
      this.maintenanceMessage = maintenanceMessage;
    },
  },
};
</script>

<style>
#maintenance-view {
  font: normal normal 400 16px Noto Sans JP;
  /* 高さ・幅に、枠線・ボーダーを含める */
  box-sizing: border-box;
  letter-spacing: -0.38px;
  line-height: 24px;
  margin: 0px;
  padding: 0px;
  padding-bottom: 78px;
  text-align: center;
}

.title-container {
  margin: 0px 20px 24px 0px;
}

.page-title {
  text-align: center;
  font-size: 18px;
  letter-spacing: 0px;
  color: #000000e6;
  padding-top: 9px;
  padding-bottom: 9px;
}

.message-container {
  padding: 0 16px 0 16px;
}

.emphasize {
  text-decoration: underline;
  letter-spacing: -0.38px;
  color: #000000e6;
}

.main-message-container {
  padding: 24px 16px;
}

.main-message-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #0000000a;
  border-radius: 8px;
}

.main-maintenance-title {
  padding: 24px 16px 12px 16px;
}

.main-maintenance-message {
  padding: 0 16px 24px 16px;
}
</style>
